import React from "react";

var globeSvg = function globeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 16H4.37a1 1 0 0 1-.852-1.524 8.074 8.074 0 0 1-1.148-.545.993.993 0 0 1-.366-1.36c.276-.476.888-.64 1.366-.364 2.87 1.65 6.54.67 8.196-2.187A5.96 5.96 0 0 0 9.37 1.858a.993.993 0 0 1-.366-1.36c.276-.476.888-.64 1.366-.364 3.827 2.2 5.138 7.071 2.928 10.882a7.952 7.952 0 0 1-3.605 3.263A1 1 0 0 1 9 16zm-2.63-4.25a4.75 4.75 0 1 1 0-9.5 4.75 4.75 0 0 1 0 9.5z"
  }));
};

globeSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var globe = {
  category: 'icon',
  colorable: true,
  name: 'globe',
  svg: globeSvg
};